import React, { Component } from "react";
import { Icon, Button, TextArea, InputGroup } from "@blueprintjs/core";
import { validate } from "validate.js";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../../components/LoadingIndicator";
import Moment from 'react-moment';
import FileInput from '../FileInput';
import GoogleLocation from '../GoogleLocation';
import GetUserLocation from '../GetUserLocation';
import Image from '../Image';
import ReactPasswordStrength from 'react-password-strength';
import { validatePhoneNumber } from '../../utils/utils';

//TODO: refactor all;
class UserAccountForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user_form: {
                u_name: "",
                f_name: "",
                l_name: "",
                email: "",
                address: "",
                description: "",
                pw: "",
                confirm_password: "",
                base64_image: "",
                country: "",
                city: "",
                lat: "",
                lon: "",
                mobile_phone: ""
            },
            validation_errors: {},
            avatar: undefined,
            show_location_modal: false,
            location: { lat: 0, lon: 0 },
            show_location_loader: false
        };
    }

    componentDidMount() {
        this.setState(state => ({ user_form: { ...state.user_form, ...this.props.profile }, avatar: this.props.profile.image_url }))
    }

    updateFields = (event) => {
        let user_form = {};
        if ("password" in event) {
            user_form = {
                ...this.state.user_form,
                pw: event.password
            }
            if (event.password === "") {   //if password field is empty clear also confirm_password field  
                user_form.confirm_password = "";
            }
        } else {
            user_form = {
                ...this.state.user_form,
                [event.target.id]: event.target.value
            }
        }
        this.setState({ user_form });
    }

    checkForChangedFields = () => {
        let changes = {};
        ["f_name", "l_name", "email", "address", "description", "pw", "country", "city", "lat", "lon", "base64_image", "mobile_phone"].forEach((key) => {
            if (this.state.user_form[key] || key === 'mobile_phone') {
                if (key in this.props.profile) {
                    if (this.props.profile[key] !== this.state.user_form[key]) {
                        changes[key] = this.state.user_form[key];
                    }
                } else {
                    changes[key] = this.state.user_form[key];
                }
            }
        });

        if ('email' in changes) {
            changes['u_name'] = changes['email'];
        }
        return changes;
    }

    submitForm = (e) => {
        e.preventDefault();
        //TODO: find a better way or place to validate password 
        const changed_fields = this.checkForChangedFields();

        if (Object.keys(changed_fields).length === 0) {
            return;
        }

        validate.validators.password = function (value, options, key, attributes) {
            if (value.length === 0 || value.length >= 6) {
                return null;
            }

            if (value.length > 0 || value.length < 6) {
                return "^errors.register.password_to_short";
            }
        };

        let validationErrors = validate(
            this.state.user_form,
            { ...this.props.validators, pw: { password: "options" } }
        );

        if (changed_fields.mobile_phone) {
            const error = validatePhoneNumber(changed_fields.mobile_phone);
            if (error) {
                if (!validationErrors) {
                    validationErrors = {};
                }
                validationErrors.mobile_phone = [error];
            }
        }

        this.setState({
            validation_errors: validationErrors ? validationErrors : {}
        });

        if (validationErrors && Object.keys(validationErrors).length) {
            window.scrollTo(0, 0);
        }

        if (!validationErrors) {
            this.props.onUpdate(changed_fields);
        }
    }

    avatarChanged = (image, base64_image) => {
        this.updateFields({ target: { id: "base64_image", value: base64_image } });
        this.setState({ avatar: image });
    }

    selectedLocation = (location) => {
        this.setState({
            show_location_modal: false,
            user_form: { ...this.state.user_form, ...location, lat: String(location.lat), lon: String(location.lng) }
        });
    }

    showLocationModal = () => {
        if (this.state.user_form.lat && this.state.user_form.lon) {
            this.setState({ show_location_modal: true, location: { lat: this.state.user_form.lat, lon: this.state.user_form.lon } })
        } else {
            this.setState({ show_location_loader: true });
            GetUserLocation((position) => {
                this.setState({ show_location_modal: true, show_location_loader: false, location: { lat: position.coords.latitude, lon: position.coords.longitude } });
            }, (error) => {
                this.setState({ show_location_modal: true, show_location_loader: false });
            })
        }
    }

    render() {
        return (
            <>
                <div className="user-meta">
                    <GoogleLocation
                        location={{ lat: this.state.location.lat, lng: this.state.location.lon }}
                        showModal={this.state.show_location_modal}
                        onClose={() => { this.setState({ show_location_modal: false }) }}
                        onSave={this.selectedLocation}
                    />
                    <FileInput onImageSelected={this.avatarChanged} >
                        <div className="avatar">
                            <Image src={this.state.avatar} />
                            <Icon
                                icon="person"
                                iconSize="48"
                                className="icon"
                            />
                        </div>
                    </FileInput>
                    <div className="name">
                        <h1>{this.state.user_form.f_name} {this.state.user_form.l_name}</h1>
                        <p>
                            <Translate value="user_details.member_since" />
                            <Moment date={this.props.profile.c_at} format=" MMMM D, YYYY" />
                        </p>
                        <div className="cta-wrapper">
                            <Button intent="primary" className="primary-outline small" onClick={this.props.goToPublicProfile}>
                                <Translate value="user_details.public_profile" />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="account-form">
                    <form onSubmit={this.submitForm}>
                        <div className={
                            this.state.validation_errors.f_name
                                ? "form-group error"
                                : "form-group"
                        }
                        >
                            <label htmlFor="f_name">
                                {this.state.validation_errors.f_name ?
                                    <Translate
                                        value={this.state.validation_errors.f_name[0]}
                                    />
                                    :
                                    <Translate
                                        value={"user_details.labels.first_name"}
                                    />
                                }
                            </label>
                            <InputGroup
                                type="text"
                                placeholder={I18n.t("user_details.placeholders.first_name")}
                                fill={true}
                                id="f_name"
                                value={this.state.user_form.f_name}
                                intent={this.state.validation_errors.f_name ? "danger" : ""}
                                className="no-icon"
                                onChange={this.updateFields}
                            />
                        </div>
                        <div className={
                            this.state.validation_errors.l_name
                                ? "form-group error"
                                : "form-group"
                        }>
                            <label htmlFor="l_name">
                                {this.state.validation_errors.l_name ?
                                    <Translate
                                        value={this.state.validation_errors.l_name[0]}
                                    />
                                    :
                                    <Translate
                                        value={"user_details.labels.last_name"}
                                    />
                                }
                            </label>
                            <InputGroup
                                type="text"
                                placeholder={I18n.t("user_details.placeholders.last_name")}
                                fill={true}
                                id="l_name"
                                value={this.state.user_form.l_name}
                                intent={this.state.validation_errors.l_name ? "danger" : ""}
                                className="no-icon"
                                onChange={this.updateFields}
                            />
                        </div>
                        <div className={
                            this.state.validation_errors.email
                                ? "form-group error"
                                : "form-group"
                        }>
                            <label htmlFor="email">
                                {this.state.validation_errors.email ?
                                    <Translate
                                        value={this.state.validation_errors.email[0]}
                                    />
                                    :
                                    <Translate
                                        value={"user_details.labels.email"}
                                    />
                                }
                            </label>
                            <InputGroup
                                type="text"
                                placeholder={I18n.t("user_details.placeholders.email")}
                                fill={true}
                                id="email"
                                value={this.state.user_form.email}
                                intent={this.state.validation_errors.email ? "danger" : ""}
                                className="no-icon"
                                onChange={this.updateFields}
                            />
                        </div>
                        <div className={
                            this.state.validation_errors.mobile_phone
                                ? "form-group error"
                                : "form-group"
                        }>
                            <label htmlFor="mobile_phone">
                                {this.state.validation_errors.mobile_phone ?
                                    <Translate
                                        value={this.state.validation_errors.mobile_phone[0]}
                                    />
                                    :
                                    <Translate
                                        value={"b2b.phone"}
                                    />
                                }
                            </label>
                            <InputGroup
                                type="text"
                                placeholder={I18n.t("user_details.placeholders.mobile_phone")}
                                fill={true}
                                id="mobile_phone"
                                value={this.state.user_form.mobile_phone}
                                intent={this.state.validation_errors.mobile_phone ? "danger" : ""}
                                className="no-icon"
                                onChange={this.updateFields}
                            />
                        </div>
                        <div className={
                            this.state.validation_errors.address
                                ? "form-group error"
                                : "form-group"
                        } onClick={this.showLocationModal}>
                            <label htmlFor="address">
                                {this.state.validation_errors.address ?
                                    <Translate
                                        value={this.state.validation_errors.address[0]}
                                    />
                                    :
                                    <Translate
                                        value={"user_details.labels.location"}
                                    />
                                }
                            </label>
                            <InputGroup
                                readOnly={true}
                                type="text"
                                placeholder={I18n.t("user_details.placeholders.location")}
                                fill={true}
                                id="address"
                                value={this.state.user_form.address}
                                className="no-icon has-button"
                                rightElement={
                                    this.state.show_location_loader ? <LoadingIndicator /> :
                                        <Button className="input-button right">
                                            <Icon
                                                icon="locate"
                                                iconSize="20"
                                                className="icon"
                                            />
                                        </Button>
                                }
                            />
                        </div>
                        <div className={
                            this.state.validation_errors.description
                                ? "form-group error"
                                : "form-group"
                        }>
                            <label htmlFor="description">
                                {this.state.validation_errors.description ?
                                    <Translate
                                        value={this.state.validation_errors.description[0]}
                                    />
                                    :
                                    <Translate
                                        value={"user_details.labels.description"}
                                    />
                                }
                            </label>
                            <TextArea
                                placeholder={I18n.t("user_details.placeholders.description")}
                                value={this.state.user_form.description}
                                fill={true}
                                id="description"
                                onChange={this.updateFields}
                            />
                        </div>
                        <div className={
                            this.state.validation_errors.pw
                                ? "form-group error"
                                : "form-group"
                        }>
                            <label htmlFor="password">
                                {this.state.validation_errors.pw ?
                                    <Translate
                                        value={this.state.validation_errors.pw[0]}
                                    />
                                    :
                                    <Translate
                                        value={"user_details.labels.change_password"}
                                    />
                                }
                            </label>
                            {/* <InputGroup
                            type={this.state.user_form.pw.length?"password":"text"}
                            placeholder={I18n.t("user_details.placeholders.change_password")}
                            fill={true}
                            id="pw"                            
                            className="no-icon has-button"
                            value = {this.state.user_form.pw}
                            onChange={this.updateFields}
                        /> */}

                            <ReactPasswordStrength
                                minLength={5}
                                minScore={2}
                                scoreWords={[I18n.t('password_score.weak'), I18n.t('password_score.okay'), I18n.t('password_score.good'), I18n.t('password_score.strong'), I18n.t('password_score.stronger')]}
                                tooShortWord={I18n.t('password_score.too_short')}
                                changeCallback={this.updateFields}
                                className="user-account-pass"
                                inputProps={
                                    {
                                        type: this.state.user_form.pw.length ? "password" : "text",
                                        name: "password", autoComplete: "off",
                                        className: "bp5-input",
                                        placeholder: I18n.t("sign_up.placeholders.password")
                                    }
                                }
                            />
                        </div>
                        <div className={
                            this.state.validation_errors.confirm_password
                                ? "form-group error"
                                : "form-group"
                        }>
                            <label htmlFor="confirm_password">
                                {this.state.validation_errors.confirm_password ?
                                    <Translate
                                        value={this.state.validation_errors.confirm_password[0]}
                                    />
                                    :
                                    <Translate
                                        value={"user_details.labels.confirm_password"}
                                    />
                                }
                            </label>
                            <InputGroup
                                disabled={this.state.user_form.pw === ""}
                                type="password"
                                placeholder={I18n.t("user_details.placeholders.confirm_password")}
                                fill={true}
                                id="confirm_password"
                                className="no-icon has-button"
                                value={this.state.user_form.confirm_password}
                                onChange={this.updateFields}
                            />
                        </div>
                        {this.props.isLoading && <LoadingIndicator />}
                        {!this.props.isLoading &&
                            <Button intent="primary" type="submit" fill={true} onClick={this.submitForm}>
                                <Translate
                                    value={"user_details.save_profile"}
                                />
                            </Button>
                        }
                    </form>
                </div>
            </>
        )
    }
}

export default UserAccountForm;